import React from 'react';
import { StoreContext } from './context';

export const StoreProvider: React.FC<{ children: React.ReactNode; state: object }> = ({ children, state }) => {
    return <StoreContext.Provider value={state}>{children}</StoreContext.Provider>;
};
